import { store } from '@bom-nextgen-keycloak/web/core';
import { keycloak } from '@bom-nextgen-keycloak/web/shared/util';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import './main.css';

const eventLogger = (event: unknown, error: unknown) => {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV === 'development') {
    console.log('onKeycloakEvent', event, error);
  }
};

const tokenLogger = (tokens: unknown) => {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV === 'development') {
    console.log('onKeycloakTokens', tokens);
  }
};

ReactDOM.render(
  <ReactKeycloakProvider
    initOptions={{
      pkceMethod: 'S256',
    }}
    authClient={keycloak}
    onEvent={eventLogger}
    onTokens={tokenLogger}
  >
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </ReactKeycloakProvider>,
  document.getElementById('root')
);
